import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export default function useGetMetricInfo({ metadata, config = {} } = {}) {
  const { addNotification } = useNotificationStore();
  return useQuery(
    ['explore-sources-info', metadata.id],
    () => axios.get(`api/v1/agent/report/followup/sources/${metadata.id}`),
    {
      ...config,
      onError: (error) => {
        addNotification({ type: 'error', title: error.message });
      },
    }
  );
}
